import { schema } from "normalizr";
import ctaSchema from "./cta";
import deviceSchema from "./device";
import imageSchema from "./image";

const pageSchema = new schema.Entity(
    "pages",
    {
        deviceId: deviceSchema,
        image: imageSchema,
        ctas: [ctaSchema]
    },
    {
        idAttribute: "id"
    }
);

export default pageSchema;



// WEBPACK FOOTER //
// ./src/schemas/page.js